import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const billingNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.billing_partner, {
      displayName: 'Partner',
      children: [
        SolNavbarItem.of(PrototypeRouteId.billing_partner_dashboard, {
          displayName: 'Dashboard',
          icon: SolIcon.asm_dashboard,
        }),
        SolNavbarItem.of(PrototypeRouteId.billing_partner_scope, {
          displayName: 'Scope',
          icon: SolIcon.asm_scope,
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.billing_partner_usage, {
      displayName: 'Partner / Usage',
      children: [
        SolNavbarItem.of(PrototypeRouteId.billing_partner_usage_billing, {
          displayName: 'Billing',
          icon: SolIcon.usage,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(PrototypeRouteId.billing_partner_usage_billing_overview, {
              displayName: 'Billing',
            }),
            SolNavbarItem.of(PrototypeRouteId.billing_partner_usage_breakdown, {
              displayName: 'Breakdown',
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.billing_admin_usage, {
      displayName: 'Administration / Usage',
      children: [
        SolNavbarItem.of(PrototypeRouteId.billing_admin_usage_billing, {
          displayName: 'Billing',
          icon: SolIcon.usage,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(PrototypeRouteId.billing_admin_usage_billing_overview, {
              displayName: 'Billing',
            }),
            SolNavbarItem.of(PrototypeRouteId.billing_admin_usage_breakdown, {
              displayName: 'Breakdown',
            }),
          ],
        }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
